import * as React from "react";
import { useState, useEffect } from "react";
import { TableBody, TableRow, TableCell, Box, Chip, TablePagination, Typography } from "@mui/material";
import { capitalize } from "@mui/material/utils";
import { readStringDate, monthsArray } from "../../../function utils/functionUtils";

import useTable from "../../../component/UseTable/UseTable_v1";
import BackdropComp from "../../../component/MuiReusableComponents/backdrop/backdrop";
import { useSelector, useDispatch } from "react-redux";
import { setPage, setRowsPerPage, rowsPerPageExpenseSelector, pageExpenseSelector } from "../../../store1/expense data/expenseData.slice.selector";


const ExpenseTable = (props) => {
  const {
    data,
    headCells = [],
    dispatchAPI,
    rowsCount,
    isLoading,
    loadingMessage,
    pageSize,
    pageIndex,
    setPageSize,
    setPageIndex,
    pathName,
    ActionComponent,
  } = props;

  const dispatch = useDispatch()
  const page = useSelector(pageExpenseSelector)
  const rowsPerPage = useSelector(rowsPerPageExpenseSelector)
  const [prevPath, setPrevPath] = useState("");
  const [userData, setUserData] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const fetchData = () => {
    dispatchAPI();
  };
  const handleChangePage = (event, newPage) => {
    dispatch(setPage(newPage + 1))
    fetchData();
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch(setRowsPerPage(parseInt(event.target.value)));
    dispatch(setPage(1));
    fetchData();
  };

  useEffect(() => {
    setUserData(data);
    if (prevPath !== pathName) {
      dispatch(setPage(1));
      dispatch(setRowsPerPage(10));
    }
    setPrevPath(pathName);
  }, [data, pathName]);

  const {
    TblContainer,
    TblHeader,
    TblPagination,
    tblDataAfterPaginationAndSorting,
    emptyRows,
  } = useTable(
    userData,
    headCells,
    filterFn,
    fetchData,
    rowsCount,
    pageSize,
    pageIndex
  );

  return (
    <>
      <>
        <Box>
          <BackdropComp message={loadingMessage} isLoading={isLoading} />
        </Box>
        <TblContainer>
          <TblHeader />
          <TableBody>
            {userData?.map((row, idx) => (
              <TableRow key={row.id} size="small">
                {headCells.map((head, idxHead) => {

                  if (head.id === "id" && head.label === "S No.") {
                    const serialNumber = page * rowsPerPage + idx + 1 - rowsPerPage;
                    return <TableCell key={`${idx}${idxHead}`}>{serialNumber}</TableCell>;
                  }
                  else if (
                    head.id === "added_date" ||
                    head.id === "added_date_time" ||
                    head.id === "expense_date" ||
                    head.id === "approval_date" ||
                    head.id === "run_date"
                  ) {
                    return (
                      <TableCell align="center">{readStringDate(row[head.id])}</TableCell>
                    );
                  }

                  if (head.id === "total_amount") {
                    return (
                      <TableCell align="right" size="small" key={`${idx}${idxHead}`}>
                        {row.total_amount ? row.total_amount : row.amount}
                      </TableCell>
                    );
                  }

                  if (head.id === "action") {
                    return (
                      <TableCell
                        size="small"
                        key={`${idx}${idxHead}`}
                        sx={{ width: "80px" }}
                      >
                        <ActionComponent
                          row={row}
                          pageSize={pageSize}
                          pageIndex={pageIndex}
                        />
                      </TableCell>
                    );
                  }

                  if (head.id === "month") {
                    return (
                      <TableCell size="small" align="left">
                        {monthsArray[row[head.id] - 1]}
                      </TableCell>
                    );
                  }

                  if (
                    head.id === "approval_status") {
                    switch (row[head.id]) {
                      case -1: {
                        return (
                          <TableCell align="right">
                            <Chip
                              color="error"
                              variant="outlined"
                              label={"Rejected"}
                            />
                          </TableCell>
                        );
                      }

                      case 1: {
                        return (
                          <TableCell align="right">
                            <Chip
                              color="success"
                              variant="outlined"
                              label={"Approved"}
                            />
                          </TableCell>
                        );
                      }
                      case 0:
                        return (
                          <TableCell align="right">
                            <Chip
                              color="secondary"
                              variant="outlined"
                              label={"Pending"}
                            />
                          </TableCell>
                        );

                      default:
                        return <span>Something went wrong</span>;
                    }
                  }
                  return (
                    <TableCell key={`${idx}${idxHead}`} size="small">
                      {capitalize(String(row[head.id] || ''))}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow
                style={{
                  height: 53 * emptyRows,
                }}
              >
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
        </TblContainer>

        {rowsCount === 0 ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: 2 }}>
            <Typography variant="h5">
              No Data Found
            </Typography>
          </Box>
        ) : null}

        {rowsCount > 0 && (
          <TablePagination
            rowsPerPageOptions={[10, 25, 35, 45, 75, 100, 200]}
            component="div"
            count={rowsCount}
            rowsPerPage={rowsPerPage}
            page={page - 1}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </>
    </>
  );
};
export default ExpenseTable;